<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'

import interactiveToggleService from '@/services/embeds/plugin/interactive.toggle.service'
import { useIdeStore } from '@/stores/embeds/ide.store'
import { useEmbedConfigureStore } from '@/stores/embeds/embedConfigure.store'

const ideStore = useIdeStore()
const embedConfigStore = useEmbedConfigureStore()

const { getOnEditMode } = storeToRefs(embedConfigStore)

const {
  getInteractiveToggleHideTitle,
  getInteractiveToggleTitleName,
  getInteractiveToggleDisplay
} = storeToRefs(ideStore)

/**
 * @description handle file input click
 * @param event The event
 */
const handleFileInputClick = (event: Event) => {
  event.stopPropagation()
}
onMounted(async () => {
  await new Promise((resolve) => setTimeout(resolve, 100))
  if (getOnEditMode.value === false) {
    interactiveToggleService.initInteractiveToggle()
    interactiveToggleService.onSettingChange()
  }
})
onBeforeUnmount(async () => {
  if (getOnEditMode.value === false) {
    interactiveToggleService.destroyInteractiveToggle()
  }
  await new Promise((resolve) => setTimeout(resolve, 100))
})
</script>

<template>
  <div
    :class="[
      'flex h-full w-full gap-2 ',
      {
        'flex-col': !getInteractiveToggleDisplay
      },
      {
        'flex-row items-center': getInteractiveToggleDisplay
      }
    ]"
  >
    <label v-if="getInteractiveToggleHideTitle" class="min-w-fit font-semibold leading-6">
      {{ getInteractiveToggleTitleName }}</label
    >
    <input
      type="checkbox"
      class="checkbox-primary text-base"
      v-model="ideStore.interActiveMode"
      @click="handleFileInputClick"
    />
  </div>
</template>
